import React from "react";

import {
  DEFAULT_TIMESTAMP_FORMAT,
  formatTimestamp,
  useTimestampFormat,
} from "./timeFormat";

/**
 * Renders the formatted text of a wall-clock ns value as a fragment, with
 * no surrounding markup. Both the clickable {@link Timestamp} and the
 * non-clickable {@link InlineTimestamp} use this helper so they share one
 * format-resolution policy.
 */
export const FormattedTimestampText: React.FC<{ ns: bigint }> = ({ ns }) => {
  const format = useTimestampFormat()?.format ?? DEFAULT_TIMESTAMP_FORMAT;
  return <>{formatTimestamp(ns, format)}</>;
};
